import styles from "./post.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
// import { useRef } from "react"; // for images to be fixed 


const Post = ({ message, asset, isPlayerPost, profilePic, profileName, additional_class}) => {

  const postClass = isPlayerPost ? styles.playerPost : styles.post;
  const givenClass = additional_class ? additional_class : postClass;

  return (
    <div className={givenClass}>
      <div className={styles.postTopRow}>
        <img src={profilePic} alt={`profile_${profileName}`} className={styles.profilePic} />
        <span className={styles.selectedProfileLabel}>{profileName}</span>
      </div>
      <div className={styles.postText}>{message}</div>
      {asset && (
        <img src={ImgBuilder[asset]} alt={asset} className={styles.postAsset} />
      )}
    </div>
  );
};
export default Post;
